import React, { useContext, useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

const reports = [
  ["contacts", "Contactos"],
  ["kanbanCards", "Tarjetas en Kanban"],
  ["pendingTasks", "Tareas pendientes"],
  ["tasks", "Tareas totales"],
  ["queues", "Colas"],
  ["agents", "Agentes"],
  ["tags", "Etiquetas"],
  ["quickAnswers", "Respuestas rápidas"],
];

const Reports = () => {
  const { isAuth } = useContext(AuthContext);
  const [summary, setSummary] = useState({});
  useEffect(() => {
    if (!isAuth) return;
    api.get("/crm/summary").then(({ data }) => setSummary(data)).catch(toastError);
  }, [isAuth]);
  return <MainContainer>
    <MainHeader><Title>Reportes</Title></MainHeader>
    <Typography color="textSecondary" style={{ marginBottom: 20 }}>Resumen operativo del CRM. Los datos se actualizan al recargar.</Typography>
    <Grid container spacing={2}>{reports.map(([key, label]) => <Grid item xs={12} sm={6} md={3} key={key}><Paper variant="outlined" style={{ padding: 20 }}><Typography color="textSecondary">{label}</Typography><Typography variant="h4" color="primary">{summary[key] ?? 0}</Typography></Paper></Grid>)}</Grid>
  </MainContainer>;
};

export default Reports;
